import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * A component that handles hash-based routing redirects.
 * This fixes issues where URLs like /#/reset-password need to go to /reset-password
 */
const HashRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if we have a hash-based route
    const hash = window.location.hash;
    
    if (hash && hash.startsWith('#/')) {
      console.log('HashRedirect: Detected hash-based route:', hash);
      
      // Extract the path from the hash (remove the leading #)
      const path = hash.substring(1);
      
      // Extract any query parameters or additional hash fragments
      const queryStartIdx = path.indexOf('?');
      const secondHashIdx = path.indexOf('#', 1);
      
      let cleanPath = path;
      let queryParams = '';
      let remainingHash = '';
      
      // Handle query parameters after the hash path
      if (queryStartIdx !== -1) {
        cleanPath = path.substring(0, queryStartIdx);
        queryParams = path.substring(queryStartIdx);
      }
      
      // Handle any additional hash after the hash path
      if (secondHashIdx !== -1) {
        if (queryStartIdx === -1 || secondHashIdx < queryStartIdx) {
          cleanPath = path.substring(0, secondHashIdx);
          remainingHash = path.substring(secondHashIdx);
        }
      }
      
      // Construct the new URL (maintaining any query params and hashes)
      const newPath = `${cleanPath}${queryParams}${remainingHash}`;
      
      console.log('HashRedirect: Redirecting to:', newPath);
      
      // Navigate to the proper path
      navigate(newPath, { replace: true });
      
      return;
    }
  }, [navigate, location]);

  return null; // This component doesn't render anything
};

export default HashRedirect;
